import { createRouter } from '@tanstack/react-router'
import { AuthData } from 'blick.react.utils'
import { queryClient } from './query'
import { QueryClient } from '@tanstack/react-query'
import { routeTree } from './routeTree.gen'

type RouterContext = {
    auth: AuthData;
    queryClient: QueryClient
}

const router = createRouter({
    routeTree,
    defaultPreload: 'intent',
    context: {
        auth: null as unknown as AuthData,
        queryClient,
    },
})

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}
export { router }
export type { RouterContext }

